"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getNormalizedStatePath_exports = {};
__export(getNormalizedStatePath_exports, {
  getNormalizedStatePath: () => getNormalizedStatePath
});
module.exports = __toCommonJS(getNormalizedStatePath_exports);
var import_getStateFromPath_mods = require("../fork/getStateFromPath-mods");
var import_path = require("./path");
function getNormalizedStatePath(param, baseUrl) {
  var { path: statePath, params } = param;
  var pathname = (0, import_path.stripPathSuffix)(statePath);
  return {
    // Strip empty path at the start
    segments: (0, import_getStateFromPath_mods.stripBaseUrl)(pathname, baseUrl).split("/").filter(Boolean).map(decodeURIComponent),
    // TODO: This is not efficient, we should generate based on the state instead
    // of converting to string then back to object
    params: Object.entries(params).reduce(function(prev, param2) {
      var [key, value] = param2;
      if (Array.isArray(value)) {
        prev[key] = value.map(function(v) {
          try {
            return decodeURIComponent(v);
          } catch (unused) {
            return v;
          }
        });
      } else {
        try {
          prev[key] = decodeURIComponent(value);
        } catch (unused) {
          prev[key] = value;
        }
      }
      return prev;
    }, {})
  };
}
//# sourceMappingURL=getNormalizedStatePath.js.map
